import { Tooltip } from "@nextui-org/react";
import { Icon } from "@iconify/react";
import { useTranslation } from "react-i18next";
import { useState } from "react";
import { CtyButton } from "@circuitry-ai/doc-ui";
import { RootState, updateUserMessage, useAppDispatch } from "@circuitry-ai/doc-data";
import { useSelector } from "react-redux";
export interface TipsAndTricksProps {
  onClick?: () => void;
  disabled?: boolean;
}
export function TipsAndTricks({ onClick, disabled = false }: Readonly<TipsAndTricksProps>) {
  const { t } = useTranslation();
  const [isOpen, setIsOpen] = useState(true);
  const dispatch = useAppDispatch();
  const activeChatAdvisor = useSelector((state: RootState) => state.advisor.activeChatAdvisor);

  const handleTipsClick = () => {
    const advisorMessage = {
      isAdvisor: true,
      isUser: false,
      message: activeChatAdvisor?.tips_and_tricks,
      metaData: [{ message_type: 'TIPS' }],
    };
    dispatch(updateUserMessage(advisorMessage));
    setIsOpen(false);
  };
  if (!isOpen) return null;

  return (
    <div className=" w-full rounded-[8px] p-1 px-2 border">
      <div className="flex items-center justify-between w-full ">
        <div className="flex items-center gap-2 ">
          <div className="flex items-center gap-2 px-2 py-1 border border-default-300 rounded-[8px] bg-content1">
            <span className="relative flex items-center justify-center w-4 h-4">
              <span className="absolute w-4 h-4 rounded-full bg-primary/10" />
              <span className="w-2 h-2 rounded-full bg-primary z-10" />
            </span>
            <span className="text-sm text-default-700 font-medium">Tips and Tricks</span>
          </div>
          <div className="text-sm text-default-700 font-medium hidden sm:block">
            {t("Click here for best practices on how to ask your Advisor questions.")}
          </div>
        </div>
        <div className="flex items-center gap-2 ">
          <Tooltip content={<span>Click</span>} placement="top-end" showArrow >
            <span >
              <CtyButton
                onPress={handleTipsClick}
                className="p-1.5 rounded-full transition-colors hover:bg-default-100"
                isIconOnly
                radius="full"
                size="sm"
                variant="light"
                isDisabled={disabled}
              >
                <Icon icon="mdi-light:arrow-right" width="20" height="20" className="text-default-500" />
              </CtyButton>
            </span>
          </Tooltip>
          <Tooltip content={<span>Close</span>} placement="top-end" showArrow>
            <span >
              <CtyButton
                onPress={() => setIsOpen((prev) => !prev)}
                className="p-1.5 rounded-full transition-colors hover:bg-default-100"
                isIconOnly
                radius="full"
                size="sm"
                variant="light"
              >
                <Icon icon="material-symbols-light:close-rounded" width="24" height="24" className="text-default-600" />
              </CtyButton>
            </span>
          </Tooltip>
        </div>
      </div>
    </div>
  )
}
export default TipsAndTricks;